<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import PageGrid from '../components/pageGrid.svelte';
	import type { SbLink } from '$lib/storyblok/types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import Button from '$lib/buttons/v3/button.svelte';

	interface Props {
		content: ISbStoryData['content'] & {
			link_url?: SbLink;
			link_label?: string;
			text: string;
		};
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="my-10 max-lg:bg-stone-4">
	<PageGrid>
		<section class="col-span-full bg-stone-4 py-12 text-center lg:rounded-2xl lg:py-11">
			<div class="lg:grid lg:grid-cols-12 lg:gap-x-6 lg:gap-y-8">
				<h1
					class="text-pretty font-serif text-[20px]/[120%] tracking-[-0.4px] text-brown-1 lg:col-start-4 lg:col-end-10 lg:text-[24px]/[120%] lg:tracking-[-0.48px]"
				>
					{content.text}
				</h1>

				{#if content.link_url && content.link_label}
					<Button
						class="btn-brown btn-large max-lg:mt-6 lg:col-start-5 lg:col-end-9"
						href={getSbUrl(content.link_url)}
						target={content.link_url?.target}
					>
						{content.link_label}
					</Button>
				{/if}
			</div>
		</section>
	</PageGrid>
</div>
